import $ from './jquery.js';

    
$('[data-toggle="modal"]').click(function(e) {
    e.preventDefault();
    var target = $($(this).attr('href'));
    target.toggleClass('active');
});

$('[data-close="modal"]').click(function(e) {
    e.preventDefault();
    $('[data-modal]').removeClass('active');
});

$(document).keyup(function(e){
    if(e.keyCode === 27) {
        $('[data-modal]').removeClass('active');
    }
});
